export default {
    PROCCESS_RES: (state, data) => {
        state[data.stateType].items = data.items;

        state[data.stateType].pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    },

    SET_CLIENT_LOADED: (state, value) => {
        state.client.editor.loaded = value;
    }
};
